"use strict";

var _toConsumableArray = require("/agent/_work/1/s/node_modules/@babel/runtime/helpers/toConsumableArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var notification_container_1 = require("./notification-container");

var notification_actions_1 = require("./notification.actions");

function notificationReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    notifications: []
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case notification_actions_1.notificationAddActionType:
      {
        var lifecycle = notification_container_1.NotificationLifecycle.NEW;
        return {
          notifications: [].concat(_toConsumableArray(state.notifications), [Object.assign(Object.assign({}, action.payload), {
            lifecycle: lifecycle
          })])
        };
      }

    case notification_actions_1.notificationUpdateActionType:
      {
        var _action$payload = action.payload,
            id = _action$payload.id,
            notification = _action$payload.notification;
        return {
          notifications: state.notifications.map(function (n) {
            if (n.id === id) {
              return Object.assign(Object.assign({}, n), notification);
            }

            return n;
          })
        };
      }

    case notification_actions_1.notificationLifecycleActionType:
      {
        var _action$payload2 = action.payload,
            _id = _action$payload2.id,
            _lifecycle = _action$payload2.lifecycle;
        return {
          notifications: state.notifications.filter(notificationHasExpired(_id, _lifecycle)).map(function (n) {
            return n.id === _id ? Object.assign(Object.assign({}, n), {
              lifecycle: _lifecycle
            }) : n;
          })
        };
      }

    default:
      return state;
  }
}

exports.notificationReducer = notificationReducer;

function notificationHasExpired(id, lifecycle) {
  return function (n) {
    return !(n.id === id && lifecycle === notification_container_1.NotificationLifecycle.EXPIRED);
  };
}